// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2LYtI","tab":"Tabs_tab__13d_n","tabActive":"Tabs_tabActive__1BYKE"};